<template>
  <div class="section section-partners" id="partners-section" data-background-color="black">
    <div data-aos="fade-left" class="img_deco_02">
    </div>
    <div class="container text-center">
      <h3 class="title deco2">{{$t(`Partners`)}}</h3>
      <div class="row" style="padding-top: 20px;">
        <div class="col box-partner text-center" v-for="(partner, index) in partners" v-bind:key="index">
          <a v-bind:href="partner.url" target="_blank">
            <img v-bind:src="`/img/partners/${partner.img}`" v-bind:width="partner.width" v-bind:style="partner.style" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      partners: [
        {
          url: "https://cryptoswordandmagic.com/",
          width: "60%",
          style: {},
          img: 'partner_01.png'
        },
        {
          url: "https://www.hashed.com/",
          width: "60%",
          style: {},
          img: 'partner_02.png'
        },
        {
          url: "https://opensea.io/",
          width: "40%",
          style: {},
          img: 'partner_03.png'
        },
        {
          url: "https://www.sandbox.game/",
          width: "60%",
          style: {'margin-top': '20px'},
          img: 'partner_04.png'
        },
        {
          url: "https://www.tokenpocket.pro/",
          width: "60%",
          style: {},
          img: 'partner_05.png'
        },
        {
          url: "https://token.im/",
          width: "60%",
          style: {'margin-top': '20px'},
          img: 'partner_06.png'
        },
        {
          url: "https://kyber.network/",
          width: "50%",
          style: {'margin-top': '10px'},
          img: 'partner_15.png'
        },
        {
          url: "https://makerdao.com/",
          width: "60%",
          style: {'margin-top': '20px'},
          img: 'partner_14.png'
        },
        {
          url: "https://www.dapp.com/",
          width: "60%",
          style: {'margin-top': '20px'},
          img: 'partner_07.png'
        },
        {
          url: "http://dappbirds.com/",
          width: "60%",
          style: {'margin-top': '20px'},
          img: 'partner_08.png'
        },
        {
          url: "https://www.dappx.com/",
          width: "60%",
          style: {'margin-top': '20px'},
          img: 'partner_09.png'
        },
        {
          url: "https://dapptotal.com/",
          width: "60%",
          style: {'margin-top': '30px'},
          img: 'partner_10.png'
        },
        {
          url: "https://www.dapppocket.io/",
          width: "70%",
          style: {'margin-top': '20px'},
          img: 'partner_11.png'
        },
        {
          url: "https://dappstats.com/",
          width: "60%",
          style: {'margin-top': '30px'},
          img: 'partner_12.png'
        },
        {
          url: "https://www.topdapp.com/",
          width: "60%",
          style: {'margin-top': '20px'},
          img: 'partner_13.png'
        },
        {
          url: "https://dapponline.io/",
          width: "60%",
          style: {'margin-top': '20px'},
          img: 'partner_16.png'
        },
        {
          url: "https://planetariumhq.com/",
          width: "60%",
          style: {'margin-top': '25px'},
          img: 'partner_17.png'
        },
        {
          url: "https://egamers.io/",
          width: "60%",
          style: {'margin-top': '25px'},
          img: 'partner_18.png'
        },
        {
          url: "https://blocto.portto.io/",
          width: "60%",
          style: {'margin-top': '20px'},
          img: 'partner_19.png'
        }
      ]
    };
  }
};
</script>
<style></style>
